module.exports = __webpack_public_path__ + "img/unlocked.45a6ab25.svg";